import React from "react";
import { Link } from "react-router-dom";
import RumizLogo from "../Assets/Rumiz_logo.svg";

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-content">
      <div className="footer-brand">
        <div className="footer-logo-group">
          <img src={RumizLogo} alt="Rumiz Logo" className="footer-logo" />
        </div>
        <div className="footer-copyright">
          © 2025 Rumiz בע"מ<br />
          נוצר באהבה <span style={{color: "#e25555"}}>❤️</span>
        </div>
      </div>
      <div className="footer-links footer-terms">
        <div className="footer-title">תנאים ופרטיות</div>
        <Link to="/privacy-policy">מדיניות פרטיות</Link>
        <Link to="/terms-and-conditions">תנאי שימוש</Link>
      </div>
      <div className="footer-links footer-help">
        <div className="footer-title">עזרה</div>
        <a href="#contact">צור קשר</a>
      </div>
    </div>
    <div className="footer-bottom">
      כל הזכויות שמורות © 2025 Rumiz בע"מ
    </div>
  </footer>
);

export default Footer; 